import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setCurrentClient } from "../store/actions/user";

/**
 * Platform user leaving a client's context (CLIENT_VIEW) back to the
 * Manage Clients list: clears the selected client (id + name), returns the
 * sidebar to PLATFORM mode and navigates home. Used by the topbar client
 * chip's exit (×).
 */
export function useExitClientView() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  return () => {
    dispatch(setCurrentClient(null, null));
    dispatch({ type: "SET_MODE", payload: "PLATFORM" });
    dispatch({ type: "SET_SIDEBAR_OPEN_KEYS", payload: [] });
    dispatch({ type: "SET_ACTIVE_PANEL_KEY", payload: null });
    navigate("/home");
  };
}
